import React from "react"

import { TCLabel, TCTitleLabel } from "../../../../components/TopCourtComponents/Label/TopCourtLabel";
import { Grid, Switch } from "@mui/material";
import ScheduleHoursComponent from "views/pages/courts/component/scheduleHoursComponent";

function TCSchedule({
    title,
    lockEdit,
    operationalHours,
    restHours,
    orderSchedule,
    setLockEdit,
    setOperationalHours,
    setRestHours,
}) {
    return (
        <>
            <Grid item xs={12}><TCTitleLabel>{title}</TCTitleLabel></Grid>
            <Grid item container pt={2} xs={12} alignItems={"center"}>
                <Grid item>
                    <TCLabel>Lock Edit</TCLabel>
                </Grid>
                <Grid item>
                    <Switch checked={lockEdit} onChange={() => {
                        setLockEdit(!lockEdit)
                    }} />
                </Grid>
            </Grid>
            {/* wrap="nowrap" sx={{ overflowX: "auto" }} */}
            <Grid pt={1} item container direction='row' xs={12}>
                {/* List Inputan Date dan Hours */}
                <ScheduleHoursComponent
                    setCourt={(e) => {
                        setOperationalHours(e)
                    }}
                    setRest={(e) => {
                        setRestHours(e)
                    }}
                    currOpsHours={operationalHours}
                    currRestHours={restHours}
                    setShowSummary={() => { }}
                    exceptionHours={orderSchedule}
                />
            </Grid>
        </>
    )
}

export default TCSchedule